import Model from '@/lib/data/Model';

class FormQuestionDataDocument extends Model {
    static idProperty = 'id';

    fields = ['id', 'form_ques_id', 'form_ques_data_id', 'file_storage_id', 'mime_type', 'name'];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'remove',
            url: '/visit/docs/delete',
            params: ['file_storage_id'],
        },
    ];
}

export default FormQuestionDataDocument;
